export default __webpack_public_path__ + "static/media/menu.503df96f.svg";